var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.ContourLayer = new Class({
    Extends: OCS.Viewer.Classes.VectorLayer,
    debug: false,
    class_name: "ContourLayer",
    options: {      
        style_type: 'line'
    }  
});